import React, { useRef, useState, useEffect, useContext } from "react";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { InputTextarea } from "primereact/inputtextarea";
import { MultiSelect } from "primereact/multiselect";
import { Divider } from "primereact/divider";
import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";

import { applicationsService } from "../../../services/ApplicationsService";
import { AppDB } from "../../../App";
import ScreenLoader, { ScreenLoader2 } from "../../../componets/ScreenLoader";
import { UserDelimitation } from "../../users/UserDelimitation";
import CountryCodeComponet from "../../../componets/CountryCodeComponet";
import { Calendar } from "primereact/calendar";
import GenericFileCapture from "../../../componets/GenericFileCapture";
import GenericUploadFileTable from "../../../componets/GenericUploadFileTable";
import { changeLang } from "../../../componets/Language/ChangeLang";
import { SpaceHighlightInput } from "../../../componets/SpaceHighlightInput";

const AddCorrections = ({ setShowAddCorrections, showAddcorrections, loading, rawCorrectionsData, setLoading, voterData, submitCorrection }) => {
	const { lookUp, toast } = useContext(AppDB);

	const [delimitation, setDelimitation] = useState(null);
	const [attributes, setAttributes] = useState([]);
	const [selectedAttributes, setSelectedAttributes] = useState([]);
	const [isLoading, setIsLoading] = useState(false);


	const [correctionData, setCorrectionData] = useState(rawCorrectionsData);

	const [showFileUploader, setShowFileUploader] = useState(false);
	const [fileUploaderDocuments, setFileUploaderDocuments] = useState([]);
	const [villageSelected, setvillageSelected] = useState(null);
	const [refresh, setRefresh] = useState(false);
	var [formErrorMessage, setFormErrorMessage] = useState({});

	const [docList, setDocList] = useState([]);
	useEffect(() => {
		setCorrectionData(rawCorrectionsData);
		setFileUploaderDocuments([]);
		setSelectedAttributes([]);
		setDelimitation(null);
	}, [showAddcorrections]);

	const requiredFieldsByAttribute = {
		4: ["firstName"],
		5: ["middleName"],
		6: ["surname"],
		7: ["dateOfBirth"],
		3: [],
		2: ["disabilityID"]
	};

	useEffect(() => {
		if (!lookUp || !lookUp.binaryTypes) return;

		const form = lookUp.binaryTypes.find((b) => b.id === 14);

		setDocList(form ? [form] : []);
	}, [lookUp]);

	useEffect(() => {
		if (voterData?.voterID) {
			setCorrectionData((prev) => ({
				...prev,
				voterID: voterData.voterID,
				fromVillageID: voterData?.village?.villageID
			}));
		}

		applicationsService
			.getCorrectionAttributes()
			.then((data) => setAttributes(data.correctionAttributes || []))
			.catch((err) => console.error("Failed to fetch attributes:", err));
	}, [voterData]);

	useEffect(() => {
		if (!fileUploaderDocuments || fileUploaderDocuments.length === 0) {
			setCorrectionData((prev) => ({ ...prev, binaryData: [] }));
			return;
		}

		const cleaned = [...fileUploaderDocuments].map((doc) => {
			var base64 = doc?.binaryData.split(",");
			if (base64?.length >= 2) {
				base64 = base64[1];
			} else {
				base64 = doc?.binaryData;
			}
			return {
				binaryTypeID: doc?.documentTypeID ?? 14,
				fileExt: doc?.fileExt || doc?.fileExtension || null,
				description: doc?.description ?? "",
				binaryData: base64
			};
		});

		setCorrectionData((prev) => ({
			...prev,
			binaryData: cleaned
		}));
	}, [fileUploaderDocuments]);
	// Automatically clear errors when the corresponding field gets a value
	useEffect(() => {
		setFormErrorMessage((prevErrors) => {
			if (!prevErrors || Object.keys(prevErrors).length === 0) return prevErrors;

			const updatedErrors = { ...prevErrors };
			Object.keys(prevErrors).forEach((field) => {
				const value = correctionData[field];

				// Clear error if the field now has a value
				if (
					value !== null &&
					value !== undefined &&
					(!Array.isArray(value) || value.length > 0) &&
					!(typeof value === "string" && value.trim() === "")
				) {
					delete updatedErrors[field];
				}
			});

			return updatedErrors;
		});
	}, [correctionData]);

	const digitsOnly = (val) => /^\d*$/.test(val);
	const handleAttributeChange = (e) => {
		const newValue = e?.value || [];

		const isDermacation = newValue.some((a) => a.correctionAttributeID === 1);
		const nonDermacation = newValue.some((a) => a.correctionAttributeID !== 1);

		if (isDermacation && nonDermacation) {
			toast?.show({
				severity: "warn",
				summary: "Invalid Selection",
				detail: "Action not permitted. Select either Demarcation or Personal Details for this correction request, only one category may be submitted at a time.",
				life: 5000
			});
			setSelectedAttributes([]);
			setCorrectionData((prev) => ({
				...prev,
				correctionAttributeID: null,
				isTransfer: false,
				isAmendment: false
			}));
			return;
		}
		const selectedIDs = newValue.map(attr => attr.correctionAttributeID);

		setSelectedAttributes(newValue);
		setCorrectionData((prev) => ({
			...prev,
			correctionAttributeIDs: selectedIDs,
			isTransfer: selectedIDs.includes(1),
			isAmendment: !selectedIDs.includes(1),
			fromVillageID: selectedIDs.includes(1) ? voterData?.village?.villageID : null
		}));
	};
	const clearError = (field) => {
		setFormErrorMessage((prev) => {
			if (!prev[field]) return prev; // nothing to clearcountry
			const updated = { ...prev };
			delete updated[field];
			return updated;
		});
	};

	const handleSubmit = async () => {
		let errors = {};
		const selectedIDs = selectedAttributes.map((a) => a.correctionAttributeID);
		if (selectedAttributes.length === 0) {
			errors.attributes = "Please select at least one correction attribute.";
			toast?.show({
				severity: "warn",
				summary: "Invalid Selection",
				detail: "Action not permitted. Select Correction Details to correct.",
				life: 5000
			});
		}
		if (!correctionData.correctionNotes || correctionData.correctionNotes.trim() === "") {
			errors.correctionNotes = "Correction Notes are required.";
		}
		if (
			selectedIDs.includes(1) &&
			(correctionData.transferReasonID === null ||
				correctionData.transferReasonID === undefined)
		) {
			errors.transferReasonID = "Transfer reason is required for transfer requests.";
		}


		if (!correctionData.binaryData || correctionData.binaryData.length === 0) {
			errors.binaryData = "A supporting document is required.";
		}

		// --------------------------------------------------------
		// REQUIRED BY SELECTED ATTRIBUTE
		// --------------------------------------------------------

		selectedIDs.forEach((id) => {
			const requiredFields = requiredFieldsByAttribute[id] || [];

			requiredFields.forEach((field) => {
				const value = correctionData[field];

				if (value === null || value === undefined || value === "" || (Array.isArray(value) && value.length === 0)) {
					errors[field] = `Required.`;
				}
			});
		});

		if (selectedIDs.includes(3)) {
			if (!correctionData.cellPhone?.trim() && !correctionData.cellPhone2?.trim() && !correctionData.email?.trim()) {
				errors.contact = "Provide at least a cellphone number or an email address.";
			}
		}

		// --------------------------------------------------------
		// Global validations
		// --------------------------------------------------------

		if (!correctionData.voterID) {
			errors.voterID = "Voter ID is required.";
		}

		if (!correctionData.correctionNotes) {
			errors.voterID = "Correction notes is required.";
		}
		if (Object.keys(errors).length > 0) {
			setFormErrorMessage(errors);
			return;
		}
		setFormErrorMessage({});
		setIsLoading(true);

		try {
			await submitCorrection(correctionData, setCorrectionData);
		} catch (err) {
			console.error(err);
			toast?.show({
				severity: "error",
				summary: "Submit failed",
				detail: "Could not submit correction. Please try again.",
				life: 5000
			});
		} finally {
		
			setIsLoading(false);
		}
	};

	const dialogFooter = (
		<div className="flex justify-content-end gap-2">
			<Button
				label="Submit"
				icon="pi pi-check"
				className="p-button-success"
				onClick={handleSubmit}
			// disabled={isLoading || (correctionData?.isTransfer && correctionData?.transferReasonID === null)}
			/>
			<Button
				label="Cancel"
				icon="pi pi-times"
				className="p-button-secondary"
				onClick={() => {
					setShowAddCorrections(false);
					setCorrectionData(rawCorrectionsData);
				}}
			/>
		</div>
	);

	// Flags to drive layout
	const isDisabilitySelected = selectedAttributes.some((a) => a.correctionAttributeID === 2);
	const isContactSelected = selectedAttributes.some((a) => a.correctionAttributeID === 3);
	const isDelimitationSelected = selectedAttributes.some((a) => a.correctionAttributeID === 1);
	const isDateOfBirth = selectedAttributes.some((a) => a.correctionAttributeID === 7);
	const isname = selectedAttributes.some((a) => a.correctionAttributeID === 4);
	const isMiddleName = selectedAttributes.some((a) => a.correctionAttributeID === 5);
	const isSurname = selectedAttributes.some((a) => a.correctionAttributeID === 6);
	useEffect(() => {
		if (villageSelected) {
			setCorrectionData((prev) => ({
				...prev,
				toVillageID: villageSelected || null
			}));
		}
	}, [villageSelected]);
	return (
		<Dialog
			visible={showAddcorrections}
			header="Add Correction"
			modal
			style={{ width: "80vw", height: "80vh" }}
			footer={dialogFooter}
			onHide={() => {
				setShowAddCorrections(false);
				setSelectedAttributes([]);
				setCorrectionData(rawCorrectionsData);
			}}
			draggable={false}
		>
			<ScreenLoader2 visible={isLoading} style={{ position: "absolute", inset: 0, background: "rgba(217, 217, 217, 0.42)", zIndex: 999999 }} />

			<div className="p-fluid grid py-2">
				{/* Attribute Selector */}
				<div className="col-12 ">
					<Divider align="center">
						<h5 className="mt-2">
							<label htmlFor="attributes">Correction Details</label>
						</h5>
					</Divider>

					<MultiSelect
						id="attributes"
						value={selectedAttributes}
						options={attributes}
						optionLabel="name"
						optionValue={(attr) => attr}
						onChange={handleAttributeChange}
						placeholder="Select details to correct."
						display="chip"
					/>
				</div>

				{/* Conditionally render rows based on selected attributes */}
				{selectedAttributes.length > 0 && (
					<>
						{isname && (
							<div className="col-12 lg:col-4 md:col-6">
								<label>First Name</label>
								<SpaceHighlightInput
									className="w-full"
									onChange={(e) => {
										const value = e.target.value?.toUpperCase() || "";
										correctionData.firstName = value.trim() === "" ? null : value;
										setCorrectionData({ ...correctionData });
									}}
									value={correctionData?.firstName?.toUpperCase()}
								/>
								{formErrorMessage.firstName && <small className="p-error">{formErrorMessage.firstName}</small>}
							</div>
						)}
						{isSurname && (
							<div className="col-12 lg:col-4 md:col-6">
								<label>Surname</label>
								<SpaceHighlightInput
									className="w-full"
									onChange={(e) => {
										const value = e.target.value?.toUpperCase() || "";
										correctionData.surname = value.trim() === "" ? null : value;
										setCorrectionData({ ...correctionData });
									}}
									value={correctionData?.surname?.toUpperCase()}
								/>
								{formErrorMessage.surname && <small className="p-error">{formErrorMessage.surname}</small>}
							</div>
						)}
						{isMiddleName && (
							<div className="col-12 lg:col-4 md:col-6">
								<label>Middle Name</label>
								<SpaceHighlightInput
									className="w-full"
									onChange={(e) => {
										const value = e.target.value?.toUpperCase() || "";
										correctionData.middleName = value.trim() === "" ? null : value;
										setCorrectionData({ ...correctionData });
									}}
									value={correctionData?.middleName?.toUpperCase()}
								/>
								{formErrorMessage.middleName && <small className="p-error">{formErrorMessage.middleName}</small>}
							</div>
						)}
						{isDateOfBirth && (
							<div className="col-12 lg:col-4 md:col-6">
								<label>Date of Birth</label>
								<Calendar
									onChange={(e) => {
										const raw = e.value; // This is the Date object from the picker
										if (!raw) return;

										// Fix timezone by creating a pure date (YYYY-MM-DD)
										const fixedDate = new Date(Date.UTC(raw.getFullYear(), raw.getMonth(), raw.getDate()));

										setCorrectionData({
											...correctionData,
											dateOfBirth: fixedDate
										});
									}}
									dateFormat="dd/mm/yy"
									value={correctionData.dateOfBirth}
									className="w-full"
								/>
								{formErrorMessage.dateOfBirth && <small className="p-error">{formErrorMessage.dateOfBirth}</small>}
							</div>
						)}

						{isDelimitationSelected && (
							<div className="lg:col-12 md:col-6 col-4">
								<Divider align="center">
									<h5 className="mt-2">From Village:</h5>
								</Divider>
								<div className="p-fluid p-grid  section-style-block">
									<div className="p-field p-col-6 p-md-4">
										<label>{changeLang.get("national_delimitation.level1District")}</label>
										<div className=" p-inputtext p-component p-filled p-disabled">{voterData?.village?.district}</div>
									</div>
									<div className="p-field p-col-6 p-md-4">
										<label>{changeLang.get("national_delimitation.level2ConstituencyCouncil")}</label>
										<div className=" p-inputtext p-component p-filled p-disabled">{voterData?.village?.constituency}</div>
									</div>
									<div className="p-field p-col-6 p-md-4">
										<label>{changeLang.get("national_delimitation.level4RegistrationCentre")}</label>
										<div className=" p-inputtext p-component p-filled  p-disabled">{voterData?.village?.pollingDivision}</div>
									</div>
									<div className="p-field p-col-6 p-md-4">
										<label>{changeLang.get("national_delimitation.level6PollingStation")}</label>
										<div className=" p-inputtext p-component p-filled p-disabled">{voterData?.village?.registrationCentre}</div>
									</div>
									<div className="p-field p-col-6 p-md-4">
										<label>{changeLang.get("national_delimitation.level5Village")}</label>
										<div className=" p-inputtext p-component p-filled p-disabled">{voterData?.village?.name}</div>
									</div>
								</div>
								<Divider align="center">
									{" "}
									<h5 className="mt-2">To Village:</h5>
								</Divider>
								<UserDelimitation
									showVillage={true}
									showCorrectionVillage={true}
									setvillageSelected={setvillageSelected}
									hideVillageID={correctionData?.fromVillageID}
									setisLoading={setIsLoading}
									onDelimitationChanged={(selectedDelimitation) => {
										setDelimitation(selectedDelimitation);
									}}
								/>{" "}
								{/* Transfer Reason */}{" "}
								<div className="p-field p-col-12 p-md-4 mt-3">
									{" "}
									<label>
										{" "}
										Transfer Reason<span style={{ color: "red" }}>*</span>{" "}
									</label>{" "}
									<div className="p-inputgroup">
										{" "}
										<span className="p-inputgroup-addon">
											{" "}
											<i className="pi pi-user"></i>{" "}
										</span>{" "}
										<Dropdown
											value={correctionData.transferReasonID || null}
											options={lookUp?.transferReasons || []}
											onChange={(e) => setCorrectionData((prev) => ({ ...prev, transferReasonID: e.value }))}
											style={{ width: "100%" }}
											optionValue="id"
											optionLabel="name"
											autoComplete="off"
										/>
									</div>
								</div>
								{formErrorMessage.transferReasonID && <small className="p-error">{formErrorMessage.transferReasonID}</small>}
							</div>
						)}
						{isDisabilitySelected && (
							<div className="col-12 lg:col-4 md:col-6">
								<label>Disability</label>
								<Dropdown
									onChange={(e) =>
										setCorrectionData((prev) => ({
											...prev,
											disabilityID: e.value
										}))
									}
									value={correctionData.disabilityID ? correctionData.disabilityID : null}
									optionValue="id"
									optionLabel="name"
									options={lookUp?.disabilities || []}
									className="w-full"
								/>
								{formErrorMessage.disabilityID && <small className="p-error">{formErrorMessage.disabilityID}</small>}
							</div>
						)}
						{isContactSelected && (
							<>
								{/* Cellphone */}
								<div className="col-12 lg:col-4 md:col-6">
									<label>Cellphone(1):</label>
									<div className="p-inputgroup ">
										<CountryCodeComponet
											onChange={(e) =>
												setCorrectionData((prev) => ({
													...prev,
													cellPhone1CountryCodeID: e.value
												}))
											}
											value={correctionData.cellPhone1CountryCodeID}
											optionValue="id"
											optionLabel="name"
											options={lookUp?.countryCodes || []}
										/>
										<InputText
											className="w-full"
											onChange={(e) => {
												var contactNumber = e.target.value
												if (digitsOnly(contactNumber)) {
													setCorrectionData((prev) => ({
														...prev,
														cellPhone: contactNumber
													}))
												}
											}
											}
											value={correctionData.cellPhone || null}
											placeholder="Enter Cellphone Number"
										/>
									</div>
								</div>
								<div className="col-12 lg:col-4 md:col-6">
									<label>Cellphone(2):</label>
									<div className="p-inputgroup ">
										<CountryCodeComponet
											onChange={(e) =>
												setCorrectionData((prev) => ({
													...prev,
													cellPhone2CountryCodeID: e.value
												}))
											}
											value={correctionData.cellPhone2CountryCodeID}
											optionValue="id"
											optionLabel="name"
											options={lookUp?.countryCodes || []}
										/>
										<InputText
											className="w-full"
											onChange={(e) => {
												var contactNumber = e.target.value
												if (digitsOnly(contactNumber)) {
													setCorrectionData((prev) => ({
														...prev,
														cellPhone2: contactNumber
													}))
												}
											}
											}
											value={correctionData.cellPhone2 || null}
											placeholder="Enter Cellphone Number"
										/>
									</div>
								</div>
								<div className="col-12 mt-4">
									<label>Email Address</label>
									<InputText
										className="w-full"
										onChange={(e) =>
											setCorrectionData((prev) => ({
												...prev,
												email: e.target.value
											}))
										}
										value={correctionData.email || null}
										placeholder="Enter Email Address"
									/>
								</div>
								{formErrorMessage.contact && <small className="p-error">{formErrorMessage.contact}</small>}
							</>
						)}
					</>
				)}

				<div className="col-12 mt-3">
					<GenericFileCapture
						dontClearDocuments={true}
						refresh={refresh}
						setRefresh={setRefresh}
						extraAttributes={
							{
								// "candidateID": selectedCanditate.candidateID,
								// "eventID": showCandidateDialog?.event?.eventID
							}
						}
						documentTypesLookUp={docList}
						show={showFileUploader}
						setShow={setShowFileUploader}
						setDocuments={setFileUploaderDocuments}
						documents={fileUploaderDocuments}
					/>
					<GenericUploadFileTable
						header={
							<div className="col-12  lg:col-3 my-2">
								<label htmlFor="description">
									Upload Documents <span className="p-error">*</span>
								</label>
								<br />
								<>
									<Button
										label={"Upload"}
										onClick={() => setShowFileUploader(true)}
										className="p-button-success"
										icon={"pi pi-plus"}
									/>
								</>
							</div>
						}
						setDocuments={setFileUploaderDocuments}
						documents={fileUploaderDocuments}
					/>
					{formErrorMessage.binaryData && <span className="p-error">Correction supporting document is required.</span>}
				</div>
				<div className="col-12 mt-3">
					<Divider />

					<label htmlFor="correctionNotes">
						Correction Notes <span className="required-input-asterisk"></span>
					</label>

					<InputTextarea
						id="correctionNotes"
						value={correctionData.correctionNotes || ""}
						onChange={(e) =>
							setCorrectionData((prev) => ({
								...prev,
								correctionNotes: e.target.value
							}))
						}
						rows={3}
						className="required-input-asterisk"
						placeholder="Provide details of the correction."
					/>

					{formErrorMessage?.correctionNotes && <span className="p-error">{formErrorMessage.correctionNotes}</span>}
				</div>
			</div>
		</Dialog>
	);
};

export default AddCorrections;
